import React from "react";

import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";

import TimeTable from "../../../components/TimeTable/TimeTable";
import { useController, useFormContext, useWatch } from "react-hook-form";

function ProductTimeTable() {
  const { control } = useFormContext();
  const { field } = useController({ control, name: "timeTable" });
  const timeTableValue = useWatch({ name: "timeTable" });

  return (
    <Card>
      <CardBody>
        <TimeTable
          data={timeTableValue}
          inputName={"timeTable"}
          onChange={(value) => {
            if (value != null && Object.keys(value).length === 0) {
              field.onChange(null);
            } else {
              field.onChange(JSON.stringify(value));
            }
          }}
          // showMaxItems
        />
      </CardBody>
    </Card>
  );
}

export default ProductTimeTable;
